import { render } from "./IconWirelessSignal.vue?vue&type=template&id=646b11d5"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconWirelessSignal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "646b11d5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('646b11d5', __exports__)) {
    api.reload('646b11d5', __exports__)
  }
  
  module.hot.accept("./IconWirelessSignal.vue?vue&type=template&id=646b11d5", () => {
    api.rerender('646b11d5', render)
  })

}


export default __exports__